"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoyaltyEntitlementItemToJSON = exports.LoyaltyEntitlementItemFromJSONTyped = exports.LoyaltyEntitlementItemFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function LoyaltyEntitlementItemFromJSON(json) {
    return LoyaltyEntitlementItemFromJSONTyped(json, false);
}
exports.LoyaltyEntitlementItemFromJSON = LoyaltyEntitlementItemFromJSON;
function LoyaltyEntitlementItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'shortName': json['shortName'],
        'status': (0, _1.LoyaltyEntitlementStatusFromJSON)(json['status']),
        'text': !(0, runtime_1.exists)(json, 'text') ? undefined : json['text'],
    };
}
exports.LoyaltyEntitlementItemFromJSONTyped = LoyaltyEntitlementItemFromJSONTyped;
function LoyaltyEntitlementItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'shortName': value.shortName,
        'status': (0, _1.LoyaltyEntitlementStatusToJSON)(value.status),
        'text': value.text,
    };
}
exports.LoyaltyEntitlementItemToJSON = LoyaltyEntitlementItemToJSON;
//# sourceMappingURL=LoyaltyEntitlementItem.js.map